import React, {Component} from 'react';
import ReactRecaptcha from 'react-recaptcha';

export default class Recaptcha extends Component {
    componentWillMount() {
        const script = document.createElement('script');

        script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';
        script.async = true;

        document.body.appendChild(script);
    }

    reset = () => {
        this.recaptcha.reset();
    };

    handleRecaptchaLoad = () => {
        console.log('recaptcha loaded');
    };

    render() {
        return (
            <ReactRecaptcha
                ref={c => this.recaptcha = c}
                sitekey="6LeXLiIUAAAAAAea28pWjgXejLmV90WrT1KpvMzv"
                render="explicit"
                onloadCallback={this.handleRecaptchaLoad}
                {...this.props}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Recaptcha.js